var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { GetEsigningSettingsDocument } from './query.gql';
import { useEsigning } from '../../components/EsigningProvider';
export const useEsigningSettings = () => {
    const { documentId } = useEsigning();
    const _a = useQuery(GetEsigningSettingsDocument, {
        variables: { documentId },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const { requireOrder, message } = (data === null || data === void 0 ? void 0 : data.documentEsigningSettings) || {};
    const settings = {
        requireOrder: requireOrder || false,
        groupMessage: message,
    };
    return Object.assign(Object.assign({}, rest), settings);
};
